/* eslint-disable max-lines */
import Cookies from 'js-cookie'

import Utf8 from 'crypto-js/enc-utf8'
import Base64 from 'crypto-js/enc-base64url'
import { getCookiesDomain } from '@/utils/utils'
import { getStore } from '@/utils/dva'
import { readQueryFromUrl } from './utils/url'
import { checkIsTopFrame } from './utils/frame'

let _tokenResolve = null
let _tokenPromise = new Promise(resolve => {
    _tokenResolve = resolve
})

export const resolveToken = () => {
    _tokenResolve()
}

// 是否是中台
const isTerminalAdmin = window.PROJECT_CONFIG.terminalName === window.PROJECT_CONFIG.adminTerminalName

export const LONG_TOKEN = 'l_t'
let cookiesDomain = PROJECT_CONFIG.cookiesDomain

if (PROJECT_CONFIG.mode !== 'dev') {
    // 如果是中台则直接使用当前域名作为存储的作用域，不能存根域，sursung.com会和市场版域名冲突
    if (isTerminalAdmin) {
        cookiesDomain = document.domain
    } else {
        const cd = getCookiesDomain()
        cookiesDomain = `.${cd}`
    }
}

export { cookiesDomain }

const oldGetToken = () => {
    if (window.__POWERED_BY_GYL_FRAME__) {
        return Cookies.get(PROJECT_CONFIG.tokenKey) || localStorage.getItem(LONG_TOKEN)
    }
    // 来自售后预警页
    if (window.__POWERED_BY_AFTER_WARN_FRAME__) {
        if (window.__POWERED_BY_AFTER_WARN_FRAME__ERP) {
            return localStorage.getItem(LONG_TOKEN)
        }
        return Cookies.get(PROJECT_CONFIG.tokenKey)
    }
    // erp嵌套打单token存储在window
    if (window.top !== window.self) {
        return localStorage.getItem(LONG_TOKEN)
    }
}

// 获取token，注意：不要在这里加埋点，用户信息需要解析token，死在这里了！！！
export function getToken() {
    const isTopFrame = checkIsTopFrame()

    if (!isTopFrame) {
        const SESSION_TOKEN = sessionStorage.getItem(LONG_TOKEN)

        // const URL_TOKEN = readQueryFromUrl()?.token
        // // 为了解决 点了登出按钮之后，子iframe session还在的问题
        // if (URL_TOKEN && URL_TOKEN !== SESSION_TOKEN && !isUpdateToken) {
        //     setToken({ access_token: URL_TOKEN })
        //     isUpdateToken = true
        //     return URL_TOKEN
        // }

        if (!SESSION_TOKEN) {
            if (PROJECT_CONFIG.sentryMode === 'prod') {
                return oldGetToken()
            }
        }
        return SESSION_TOKEN
    }

    return Cookies.get(PROJECT_CONFIG.tokenKey)
}

// 设置token
export function setToken(token) {
    const { access_token, _notResolveToken } = token

    const isTopFrame = checkIsTopFrame()

    if (!isTopFrame) {
        sessionStorage.setItem(LONG_TOKEN, access_token)
        // 测试环境才开，为了查询一个iframe token 错误的问题
        if (PROJECT_CONFIG.sentryMode === 'prod') {
            localStorage.setItem(LONG_TOKEN, access_token)
        }
    }

    const res = Cookies.set(PROJECT_CONFIG.tokenKey, access_token, {
        expires: PROJECT_CONFIG.COOKIES_EXPIRES,
        domain: cookiesDomain
    })

    // noResolve若为true则不resolveToken，阻塞页面渲染
    if (!_notResolveToken) {
        resolveToken()
    }

    return res
}

// 清除token
export function clearToken() {
    localStorage.removeItem(LONG_TOKEN)
    return Cookies.remove(PROJECT_CONFIG.tokenKey, {
        expires: PROJECT_CONFIG.COOKIES_EXPIRES,
        domain: cookiesDomain
    })
}

export const setCookies = (key, value, options) => {
    return Cookies.set(key, JSON.stringify(value), {
        domain: cookiesDomain,
        expires: PROJECT_CONFIG.COOKIES_EXPIRES,
        ...options,
        SameSite: 'None',
        Secure: true
    })
}

export const getCookies = key => {
    const token = Cookies.get(key)
    if (token) {
        try {
            return JSON.parse(token)
        } catch (error) {
            console.error('catchError', error)
            return []
        }
    }
}

// 获取订单拆分弹窗检测状态
export const getSplitBillPop = () => {
    const splitPopkey = Cookies.get(PROJECT_CONFIG.SPLIT_BILL_POP_KEY)
    if (splitPopkey) {
        try {
            return JSON.parse(splitPopkey)
        } catch (error) {
            console.error('catchError', error)
            return []
        }
    } else {
        return []
    }
}
// 设置订单拆分弹窗检测状态
export function setSplitBillPop(arr) {
    return Cookies.set(PROJECT_CONFIG.SPLIT_BILL_POP_KEY, JSON.stringify(arr), {
        expires: 99999,
        domain: cookiesDomain,
        Secure: true,
        SameSite: 'None'
    })
}

// 清除订单拆分弹窗检测状态
export function clearSplitBillPop() {
    return Cookies.remove(PROJECT_CONFIG.SPLIT_BILL_POP_KEY, {
        expires: 99999,
        domain: cookiesDomain
    })
}

export const getIsLogin = () => {
    const $store = getStore()
    const currentUser = $store.getState()?.user?.currentUser
    const isLogin = currentUser && (currentUser.username || currentUser.userName || currentUser.coId)
    return isLogin
}

/**
 * 同步获取coId和uid，注意：代理登陆时会拼接“*”号
 */
export const getCoIdAndUid = () => {
    try {
        const attatchAgentSign = (str, isAgent) => (isAgent ? `*${str}` : str)

        const query = readQueryFromUrl()

        // 从token中解析，url上的token优先，本地存储的其次
        const jwtToken = query.token || getToken()

        if (jwtToken) {
            const tokenParts = jwtToken.split('.')
            const payload = Base64.parse(tokenParts[1])

            const payloadJson = JSON.parse(Utf8.stringify(payload))

            const { user } = payloadJson || {}

            if (user) {
                const isAgent = user.loginWay === 'AGENT' // 是否是代理

                return {
                    coId: user.coId,
                    uid: user.uid,
                    isAgent,
                    coIdWidthSymbol: attatchAgentSign(user.coId, isAgent), // 如果是代理登陆，coId前加代理标识
                    uidWidthSymbol: attatchAgentSign(user.uid, isAgent) // 如果是代理登陆，uid前加代理标识
                }
            }
        }
    } catch (error) {
        console.error(error)
    }

    return {
        coId: '',
        uid: '',
        isAgent: false,
        coIdWidthSymbol: '',
        uidWidthSymbol: ''
    }
}

/**
 * 老的api，上线时弃用，暂时做下兼容
 */
export const getCoId = () => {
    const { coId } = getCoIdAndUid()

    return coId
}

/**
 * 老的api，上线时弃用，暂时做下兼容
 */
export const getUid = () => {
    const { uid } = getCoIdAndUid()

    return uid
}

/**
 * 异步获取coId和uid
 * 短token换长token之类的，此方法确保token已完成转换
 */
export const getCoIdAndUidAsync = async () => {
    await checkTokenIsReady()

    return getCoIdAndUid()
}

/**
 * 检查token是否需要转化，如短token换长token
 */
const checkHasSimpleToken = () => {
    const query = readQueryFromUrl()

    // url上存在短token
    if (query.t || query.eTicket || query._gt) {
        return true
    }

    // 否则不需要转换
    return false
}

/**
 * 检查token是否转换完成
 */
export const checkTokenIsReady = () => {
    // 短token
    const hasSimpleToken = checkHasSimpleToken()

    // 等待转换完成
    if (hasSimpleToken) {
        return _tokenPromise
    }

    // 子应用
    const isChildFrame = !checkIsTopFrame()

    // 等待从url上或从顶层获取完成
    if (isChildFrame) {
        return _tokenPromise
    }

    return Promise.resolve()
}
